import { twMerge } from 'utilities/src/twMerge';
import React from 'react';

export type AuthorImageProps = {
  children: JSX.Element;
  classes?: string;
};

function AuthorImage({ children, classes = '' }: AuthorImageProps) {
  return (
    <div className={twMerge('m-1 mr-2 flex shrink-0 grow-0 items-center rounded-full', classes)}>{children}</div>
  );
}

export default AuthorImage;
